<h1>CISPM Changelog</h1>
<mat-grid-list cols="6" rowHeight="60px"   *ngFor = "let changelogItem of changelogData">
  <mat-grid-tile class="changelog-label" [colspan]="1"> {{changelogItem.version}} -</mat-grid-tile>
  <mat-grid-tile class="changelog-label" [colspan]="1"> {{changelogItem.dateAdded.seconds * 1000| date:'mediumDate'}} </mat-grid-tile>
  <mat-grid-tile class="changelog-label" [colspan]="4"> {{changelogItem.description}} </mat-grid-tile>
  <mat-divider></mat-divider>
</mat-grid-list>


